import { Box } from '@chakra-ui/react';

import { BulkActionContextProvider } from '../BulkActionContext';
import { PlanningMasterGrid } from './PlanningMasterGrid';

export const PlanningGrid = () => (
  <BulkActionContextProvider>
    <Box background="white" padding="12px" borderRadius="8px">
      <PlanningMasterGrid />
    </Box>
  </BulkActionContextProvider>
);
